import styled from 'styled-components';

interface StyledBorderedInfoProps {
  $width?: string | number;
  $isInline?: boolean;
  $noBorder?: boolean;
  $noMarginBottom?: boolean;
  $marginTop?: boolean;
  $hasBg?: boolean;
}
interface StyledBorderedInfoTextProps {
  $marginTop?: boolean;
}

const StyledLabelInfoAndHint = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 0 0.57rem;
`;

const StyledHintText = styled.span`
  color: ${(props) => props.theme.colors.filterLabelColor};
  font-size: ${(props) => props.theme.typography.fontSizeDefault};
  text-align: right;
`;

const StyledBorderedInfo = styled.div<StyledBorderedInfoProps>`
  display: ${(props) => (props.$isInline ? 'inline-flex' : 'flex')};
  align-items: flex-start;
  width: ${(props) => props.$width};
  padding: 0.85rem 1.71rem;
  border: ${(props) => (props.$noBorder ? 'none' : `1px solid ${props.theme.colors.secondaryBorder}`)};
  color: ${(props) => props.theme.colors.primaryText};
  border-radius: ${(props) => props.theme.customBorderRadius.borderRadiusSmall};
  margin-bottom: ${(props) => (props.$noMarginBottom ? 0 : '1.71rem')};
  margin-top: ${(props) => (props.$marginTop ? '.57rem' : '0')};
  background-color: ${(props) => (props.$hasBg ? props.theme.colors.secondaryBg : 'unset')};
  max-width: 100%;
  svg {
    margin: 0.2rem 1.14rem 0 0;
  }
`;
const StyledBorderedInfoText = styled.div<StyledBorderedInfoTextProps>`
  font-size: 1rem;
  line-height: 1.57;
  margin-top: ${(props) => (props.$marginTop ? '1rem' : '0')};
  text-align: left;
  > div {
    font-size: 1rem;
    text-align: left;
    line-height: 1.57;
  }
`;

export {
  StyledHintText, StyledLabelInfoAndHint, StyledBorderedInfo, StyledBorderedInfoText,
};
